var Queensland = "Queensland";
var Tasmania = "Tasmania";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Lãnh thổ Thủ đô Úc",
	"New South Wales": "New South Wales",
	"Northern Territory": "Lãnh thổ Bắc Úc",
	Queensland: Queensland,
	"South Australia": "Nam Úc",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Tây Úc"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
